export const centerNoticeKeys = {
    all: ['centerNotice'] as const,
    /**
     * 한 센터의 목록 **전부**를 가리키는 접두 키. 쓰기 뒤 무효화는 이걸 쓴다 —
     * 페이지별 키를 직접 넣으면 지금 보고 있지 않은 페이지가 낡은 채 남는다.
     */
    listAll: (centerId: string) => [...centerNoticeKeys.all, 'list', centerId] as const,
    /**
     * 페이지·개수까지 키에 넣는다. 빠져 있으면 page 를 바꿔도 **캐시된 첫 페이지**가 그대로 나온다.
     */
    list: (centerId: string, page?: number, limit?: number) =>
        [...centerNoticeKeys.listAll(centerId), page ?? null, limit ?? null] as const,
};
